<div>
  <div aria-labelledby="ngl_modal_header_1" aria-hidden="false" role="dialog" class="slds-modal slds-fade-in-open">
    <div class="slds-modal__container">
      <!-- Header -->
      <div class="slds-modal__header">
        <button type="button" nglbuttonicon="inverse" class="slds-modal__close slds-button slds-button--icon-inverse" (click)="closeModale()">
          <i class="material-icons" style="font-size: 22px; top: -2px; left: -2px; margin: 0; cursor: pointer">&#xE5CD;</i>
        </button>

        <h2 id="ngl_modal_header_1" class="slds-text-heading--medium">{{modalTitle}}</h2>
      </div>

      <div class="slds-modal__content slds-p-around--medium notification-modal" style="padding: 0">
        @if (!currentDetail || currentDetail.length == 0) {
          <div>
            <p class="margin-top-15-sm">Nothing to display here...</p>
          </div>
        }

        @if (currentDetail && currentDetail.length > 0) {
          <div class="list-group list-group-modal">
            @for (item of currentDetail; track item) {
              <div class="list-group-item-container">
                <div class="list-group-item">
                  <div class="row-picture" title="{{item.eventStatus}}">
                    @if (item.eventStatus != 'PENDING' && item.eventStatus != 'CORRECTED' && item.eventStatus != 'DEL_REQUESTED') {
                      <i class="material-icons event-{{type}}">&#xE878;</i>
                    }
                    @if (item.eventStatus == 'PENDING') {
                      <i class="material-icons event-pending">&#xE889;</i>
                    }
                    @if (item.eventStatus == 'CORRECTED') {
                      <i class="material-icons event-corrected">&#xE3C9;</i>
                    }
                    @if (item.eventStatus == 'DEL_REQUESTED') {
                      <i class="material-icons event-deleted">&#xE92B;</i>
                    }
                  </div>
                  <div class="row-content">
                    @if (item.eventDesc) {
                      <span class="list-group-item-heading">{{item.eventDesc}}</span>
                    }
                    @if (!item.eventDesc) {
                      <span class="list-group-item-heading">Off duty</span>
                    }
                    <div class="list-group-item-text">
                      <div class="container-fluid">
                        @if (item.eventStartDate) {
                          <div class="row">
                            <div class="col-md-12">
                              From <strong>{{(item.eventStartDate | date:'MMMM d, y') + ' [' + item.eventStartPeriod + ']'}}</strong>
                            </div>
                          </div>
                        }
                        @if (item.eventEndDate) {
                          <div class="row">
                            <div class="col-md-12">
                              to <strong>{{(item.eventEndDate | date:'MMMM d, y') + ' [' + item.eventEndPeriod + ']'}}</strong> ({{item.nbDaysOff}} days)
                            </div>
                          </div>
                        }
                        @if (!item.eventStartDate && !item.eventEndDate) {
                          <div class="row">
                            <div class="col-md-12">{{item.nbDaysOff}} days</div>
                          </div>
                        }
                        @if (item.eventStatus == 'PENDING') {
                          <div class="row" style="margin-top: 7px">
                            <div class="col-md-12">Pending - waiting for validation</div>
                          </div>
                        }
                        @if (item.eventStatus == 'CORRECTED') {
                          <div class="row" style="margin-top: 7px">
                            <div class="col-md-12">Corrected - waiting for validation</div>
                          </div>
                        }
                        @if (item.eventStatus == 'DEL_REQUESTED') {
                          <div class="row" style="margin-top: 7px">
                            <div class="col-md-12">Deletion requested - waiting for validation</div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <!----><div class="list-group-separator"></div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>

  <div class="slds-backdrop slds-backdrop--open"></div>
</div>